module.exports = {
    "dev": {
        "2": {
            "homeId": 1,
            "httpServer": "http://staging.feturtles.com",
            "configURL": "/deviceroutes/config"
        }
    },
    "prod": {
        "2": {
            "homeId": 1,
            "httpServer": "http://device.kiot.io",
            "configURL": "/deviceroutes/config"
        }
    }
}


// WEBPACK FOOTER //
// ./config/config-keys.js